@if (!readOnly) {
  <div class="mt-3"
    >
    <label>{{ 'MANAGEMENT.WORKFLOW.RULE-SELECT-DOC-FIELD-TO-SET' | translate }}</label>
    <div fxLayout="row"
      fxLayoutGap="8px"
      fxLayoutAlign="left center">
      <div class="select is-secondary is-medium offest-select">
        <select [(ngModel)]="selectedDestField"
          (change)="destFieldSelected()">
          @for (destField of destFields; track destField.systemName) {
            <option
              [ngValue]="destField.systemName">
              {{ destField.displayName }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="mt-2">
      <label>{{ 'MANAGEMENT.WORKFLOW.RULE-SELECT-DOC-FIELD-FROM-SET' | translate }}</label>
      <div fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="left center">
        @if (isDateSel) {
          <div
            class="select is-secondary is-medium offest-select">
            <select [(ngModel)]="selectedSourceType"
              (change)="sourceTypeSelected()">
              @for (sourceType of dateSourceTypes; track sourceType.id) {
                <option
                  [ngValue]="sourceType.id">
                  {{ sourceType.name }}
                </option>
              }
            </select>
          </div>
        }
        @if (isNumberSel) {
          <div
            class="select is-secondary is-medium offest-select">
            <select [(ngModel)]="selectedSourceType"
              (change)="sourceNumberTypeSelected()">
              @for (sourceType of numberSourceTypes; track sourceType.id) {
                <option
                  [ngValue]="sourceType.id">
                  {{ sourceType.name }}
                </option>
              }
            </select>
          </div>
        }
        @if (isSourceValueSel) {
          <div
            [ngStyle]="{ 'width': sourceValueWidth }">
            <input class="input is-small"
              type="text"
              [(ngModel)]="selectedSourceValue" />
          </div>
        }
        @if (isSourceSelectSel) {
          <div
            class="select is-secondary is-medium offest-select">
            <select [(ngModel)]="selectedSourceValue">
              @for (sourceSelectValue of sourceSelectValues; track sourceSelectValue.id) {
                <option
                  [ngValue]="sourceSelectValue.id">
                  {{ sourceSelectValue.name }}
                </option>
              }
            </select>
          </div>
        }
        @if (isSourceColorSel) {
          <div>
            <topo-color-picker [selectedColor]="selectedSourceValue"
              (selectedColorChanged)="colorChanged($event)"
            [selectedColorWidth]="72"></topo-color-picker>
          </div>
        }
        @if (isSourceDateFieldSel) {
          <div
            class="select is-secondary is-medium offest-select">
            <select [(ngModel)]="selectedSourceField">
              @for (sourceField of sourceDateFields; track sourceField.systemName) {
                <option
                  [ngValue]="sourceField.systemName">
                  {{ sourceField.displayName }}
                </option>
              }
            </select>
          </div>
        }
        @if (isSourceNumberFieldSel) {
          <div
            class="select is-secondary is-medium offest-select">
            <select [(ngModel)]="selectedSourceNumberField">
              @for (sourceField of sourceNumberFields; track sourceField.systemName) {
                <option
                  [ngValue]="sourceField.systemName">
                  {{ sourceField.displayName }}
                </option>
              }
            </select>
          </div>
        }
        @if (isOffsetMinusSel) {
          <div>-</div>
        }
        @if (isSourceDiffFieldSel) {
          <div
            class="select is-secondary is-medium offest-select">
            <select [(ngModel)]="selectedSourceDiffField">
              @for (sourceField of sourceDateDiffFields; track sourceField.systemName) {
                <option
                  [ngValue]="sourceField.systemName">
                  {{ sourceField.displayName }}
                </option>
              }
            </select>
          </div>
        }
        @if (isOffsetPlusSel) {
          <div>+</div>
        }
        @if (isOffsetValueSel) {
          <div>
            <input class="input is-small value-input"
              type="text"
              [(ngModel)]="selectedOffsetValue" />
          </div>
        }
        @if (isOffsetSel) {
          <div
            class="select is-secondary is-medium offest-select">
            <select [(ngModel)]="selectedOffsetType">
              @for (offsetType of offsetTypes; track offsetType.id) {
                <option
                  [ngValue]="offsetType.id">
                  {{ offsetType.name }}
                </option>
              }
            </select>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (readOnly) {
  <div
  [innerHtml]="action?.displayText | safeHtml"></div>
}
